import { SceneModelData } from "../scene.interface";
import { deepTraverseProps } from "../../reactive/util/deep-traverse-props";
import { resolveViewport } from "../../../geo";
import { MapInfo } from "../game.interface";
import { Types } from "../../reactive";

type SceneMapModel = Pick<SceneModelData, "id" | "layout">;

interface ScenarioMapModel {
  scenes?: { scene: SceneMapModel }[];
}

interface MapInfoCollectorOptions {
  viewport?: [number, number]; // Width/height of the viewport
}

export class MapInfoCollector {
  constructor(private options: MapInfoCollectorOptions = {}) {}

  public gatherFromScenarios(scenarios: ScenarioMapModel[]): MapInfo[] {
    const mapInfoArray: MapInfo[] = [];

    for (const scenario of scenarios) {
      const { scenes = [] } = scenario;
      for (const { scene } of scenes) {
        mapInfoArray.push(...this.gatherFromScene(scene));
      }
    }

    return mapInfoArray;
  }

  public gatherFromScene(scene: SceneMapModel): MapInfo[] {
    const mapInfoArray: MapInfo[] = [];

    deepTraverseProps(scene.layout, (prop, key, allProps) => {
      const mapData = this._gatherMapData(prop, key, allProps);
      if (mapData) mapInfoArray.push(mapData);
    });

    return mapInfoArray;
  }

  private _gatherMapData(
    prop: any,
    key: string,
    allProps: { [key: string]: any }
  ) {
    const bounds: Types["GeoBounds"] | undefined =
      key === "camera" ? prop?.["bounds"] : undefined;
    const styleURL = allProps["styleURL"] || undefined;

    if (bounds) {
      const viewPort = resolveViewport(bounds, this.options.viewport);
      const zoom = viewPort?.zoom || 1;
      const { ne, sw } = bounds;
      const id =
        `${styleURL || "default"}@${zoom}:` +
        `${sw.lng}_${sw.lat}_${ne.lng}_${ne.lat}`;

      return {
        id,
        bounds,
        styleURL,
        zoom,
      };
    }

    return undefined;
  }
}
